import React, {useState} from 'react'
import {makeStyles} from "@material-ui/core/styles";
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Badge from "@material-ui/core/Badge";
import Collapse from '@material-ui/core/Collapse';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';

import home from "../../icons/sidebar/homeIcon.svg";
import bookingIcon from "../../icons/sidebar/bookingIcon.svg";
import guestCardIcon from "../../icons/sidebar/guestCardIcon.svg";
import parkingLotIcon from "../../icons/sidebar/parkingLotIcon.svg";
import cameraStreamsIcon from "../../icons/sidebar/cameraStreamsIcon.svg";
import dataExportIcon from "../../icons/sidebar/dataExportIcon.svg";
import payoutsIcon from "../../icons/sidebar/payoutsIcon.svg";
import transactionIcon from "../../icons/sidebar/transactionIcon.svg";
import supportIcon from "../../icons/sidebar/supportIcon.svg";
import sanctionedPlateIcon from "../../icons/sidebar/sanctionedPlateIcon.svg";
import sanctionedTimeIcon from "../../icons/sidebar/sanctionedTimeIcon.svg";
import dashboardIcon from "../../icons/sidebar/dashboardIcon.svg";
import reportsIcon from "../../icons/sidebar/reportsIcon.svg";
import monthSummaryIcon from "../../icons/sidebar/monthSummaryIcon.svg";
import users from "../../icons/sidebar/users.svg";
import logoutIcon from "../../icons/sidebar/logoutIcon.svg";

import {LogoBox} from "../LogoBox";
import {NavLink} from "react-router-dom";
import {NotificationImportantOutlined, CenterFocusStrong} from '@material-ui/icons'

import authManager, {PERMISSIONS} from '../../lib/authManager';
import { PermissionOnly } from '../AdminOnly';
import {CurrentUserName} from "../CurrentUserName";
import {css} from "glamor";
import {
    MENU_FONT,
    COLLAPSED_ITEM,
    EXPANDED_ITEM,
    COLLAPSED_ICON,
    EXPANDED_ICON,
    MENU_TEXT_COLOR,
    MENU_ACTIVE_GREEN,
    ACTIVE_CLASS_STYLES,
} from "./constants";
import {withInstallation} from "../InstallationContext";
import {isInsightTabEnabled, isInsightsModuleEnabled} from "../../lib/insightsFeature";
import {isQrEntryExitEnabled} from "../../lib/qrFeature";
import {isConciergeModuleEnabled, isConciergePageEnabled} from "../../lib/conciergeFeature";
import {isParklioBayAccessEnabled} from "../../lib/parklioFeature";
import {INSIGHTS_PAGE_PERMISSIONS, INSIGHT_TAB_PERMISSIONS} from '../../lib/insightsPermissions';

const useStyles = makeStyles({
    activeClassName: ACTIVE_CLASS_STYLES,
});

const itemStyle = css({
    display: 'flex',
    alignSelf: 'stretch',
    alignItems: 'center',
    minHeight: 40,
    margin: '2px 8px',
    borderRadius: 8,
    textDecoration: 'none',
    fontFamily: "'Open Sans', sans-serif",
    color: MENU_TEXT_COLOR,
    fontSize: 15,
    fontWeight: 500,
    cursor: 'pointer',
    transition: 'color 0.15s ease, background 0.15s ease',
    ':visited': {color: MENU_TEXT_COLOR},
    ':hover': {color: MENU_ACTIVE_GREEN, backgroundColor: 'transparent'},
});

function PrimaryNavLink({component: Component = NavLink, ...rest}) {
    return <Component className={css(itemStyle).toString()} {...rest} />;
}

function MenuItem({icon, label, collapsed, iconSize = 20, fontSize = 15}) {
    return (
        <ListItem button style={collapsed ? COLLAPSED_ITEM : EXPANDED_ITEM}>
            <ListItemIcon style={collapsed ? COLLAPSED_ICON : EXPANDED_ICON}>
                <LogoBox size={iconSize} src={icon}/>
            </ListItemIcon>
            {!collapsed && <ListItemText primary={label} primaryTypographyProps={{style: MENU_FONT(fontSize)}}/>}
        </ListItem>
    );
}

function SidebarMenu({match, collapsed, iconSize, fontSize, notification, onNavClick, facility}) {
    const classes = useStyles();
    const [reportsOpen, setReportsOpen] = useState(false);
    const [insightsOpen, setInsightsOpen] = useState(false);
    const [conciergeOpen, setConciergeOpen] = useState(false);
    const insightsEnabled = isInsightsModuleEnabled(facility);
    const qrEnabled = isQrEntryExitEnabled(facility);
    const conciergeEnabled = isConciergeModuleEnabled(facility);
    const parklioEnabled = isParklioBayAccessEnabled(facility);

    const handleReportsClick = () => {
        setReportsOpen(prev => !prev);
    };

    const handleInsightsClick = () => {
        setInsightsOpen(prev => !prev);
    };

    const handleConciergeClick = () => {
        setConciergeOpen(prev => !prev);
    };

    return (
      <List disablePadding>
          <PermissionOnly permissions={PERMISSIONS.DASHBOARD_READ}>
              <PrimaryNavLink activeClassName={classes.activeClassName} onClick={onNavClick} to={`${match.url}/dashboard`}>
                  <MenuItem iconSize={iconSize} fontSize={fontSize} icon={dashboardIcon} label="Dashboard" collapsed={collapsed}/>
              </PrimaryNavLink>
          </PermissionOnly>

          <PermissionOnly permissions={PERMISSIONS.HOME_READ}>
              <PrimaryNavLink activeClassName={classes.activeClassName} onClick={onNavClick} to={`${match.url}/new-booking`}>
                  <MenuItem iconSize={iconSize} fontSize={fontSize} icon={home} label="Home" collapsed={collapsed}/>
              </PrimaryNavLink>
          </PermissionOnly>

          <PermissionOnly permissions={PERMISSIONS.BOOKINGS_READ}>
              <PrimaryNavLink activeClassName={classes.activeClassName} onClick={onNavClick} to={`${match.url}/bookings`}>
                  <MenuItem iconSize={iconSize} fontSize={fontSize} icon={bookingIcon} label="Bookings" collapsed={collapsed}/>
              </PrimaryNavLink>
          </PermissionOnly>

          <PermissionOnly permissions={PERMISSIONS.PARKING_UPCOMING_READ}>
              <PrimaryNavLink activeClassName={classes.activeClassName} onClick={onNavClick} to={`${match.url}/upcoming-extras`}>
                  <MenuItem iconSize={iconSize} fontSize={fontSize} icon={users} label="Upcoming Extras" collapsed={collapsed}/>
              </PrimaryNavLink>
          </PermissionOnly>

          {qrEnabled && (
              <PermissionOnly permissions={PERMISSIONS.BOOKINGS_READ}>
                  <PrimaryNavLink activeClassName={classes.activeClassName} onClick={onNavClick} to={`${match.url}/qr-codes`}>
                      <ListItem button style={collapsed ? COLLAPSED_ITEM : EXPANDED_ITEM}>
                          <ListItemIcon style={collapsed ? COLLAPSED_ICON : EXPANDED_ICON}>
                              <CenterFocusStrong style={{fontSize: iconSize, color: MENU_TEXT_COLOR}}/>
                          </ListItemIcon>
                          {!collapsed && <ListItemText primary="QR Entry/Exit" primaryTypographyProps={{style: MENU_FONT(fontSize)}}/>}
                      </ListItem>
                  </PrimaryNavLink>
              </PermissionOnly>
          )}

          <PermissionOnly permissions={PERMISSIONS.SUPPORT_READ}>
              <PrimaryNavLink activeClassName={classes.activeClassName} onClick={onNavClick} to={`${match.url}/support`}>
                  <ListItem button style={collapsed ? COLLAPSED_ITEM : EXPANDED_ITEM}>
                      <Badge variant="standard" invisible={!notification}
                             badgeContent={<NotificationImportantOutlined color="primary" style={{fontSize: 11}}/>}>
                          <ListItemIcon style={collapsed ? COLLAPSED_ICON : EXPANDED_ICON}>
                              <LogoBox size={iconSize} src={supportIcon}/>
                          </ListItemIcon>
                          {!collapsed && <ListItemText primary="Support" primaryTypographyProps={{style: MENU_FONT(fontSize)}}/>}
                      </Badge>
                  </ListItem>
              </PrimaryNavLink>
          </PermissionOnly>

          <PermissionOnly permissions={PERMISSIONS.CAMERAS_READ}>
              <PrimaryNavLink activeClassName={classes.activeClassName} onClick={onNavClick} to={`${match.url}/streams`}>
                  <MenuItem iconSize={iconSize} fontSize={fontSize} icon={cameraStreamsIcon} label="Camera Streams" collapsed={collapsed}/>
              </PrimaryNavLink>
          </PermissionOnly>

          {parklioEnabled && (
          <PermissionOnly permissions={[PERMISSIONS.PARKING_OPERATIONS_READ, PERMISSIONS.PARKING_OPERATIONS_MANAGE]}>
              <PrimaryNavLink activeClassName={classes.activeClassName} onClick={onNavClick} to={`${match.url}/parking-operations`}>
                  <MenuItem iconSize={iconSize} fontSize={fontSize} icon={parkingLotIcon} label="Parking Operations" collapsed={collapsed}/>
              </PrimaryNavLink>
          </PermissionOnly>
          )}

        <PermissionOnly permissions={[PERMISSIONS.GUEST_CARDS_READ, PERMISSIONS.GUEST_CARDS_MANAGE]}>
          <PrimaryNavLink activeClassName={classes.activeClassName} onClick={onNavClick} to={`${match.url}/settings/guestcards`}>
            <MenuItem iconSize={iconSize} fontSize={fontSize} icon={guestCardIcon} label="Guest Cards" collapsed={collapsed}/>
          </PrimaryNavLink>
        </PermissionOnly>

        <PermissionOnly permissions={[PERMISSIONS.PARKING_LOTS_READ, PERMISSIONS.PARKING_LOTS_MANAGE]}>
          <PrimaryNavLink activeClassName={classes.activeClassName} onClick={onNavClick} to={`${match.url}/settings/lots`}>
            <MenuItem iconSize={iconSize} fontSize={fontSize} icon={parkingLotIcon} label="Parking Lots" collapsed={collapsed}/>
          </PrimaryNavLink>
        </PermissionOnly>

        <PermissionOnly permissions={[PERMISSIONS.PAYOUTS_READ, PERMISSIONS.PAYOUTS_MANAGE]}>
          <PrimaryNavLink activeClassName={classes.activeClassName} onClick={onNavClick} to={`${match.url}/settings/payouts`}>
            <MenuItem iconSize={iconSize} fontSize={fontSize} icon={payoutsIcon} label="Payouts" collapsed={collapsed}/>
          </PrimaryNavLink>
        </PermissionOnly>

        <PermissionOnly permissions={[PERMISSIONS.REPORTS_EXPORT, PERMISSIONS.TRANSACTIONS_READ]}>
          <PrimaryNavLink component="div" onClick={handleReportsClick}>
            <ListItem button style={collapsed ? COLLAPSED_ITEM : EXPANDED_ITEM}>
              <ListItemIcon style={collapsed ? COLLAPSED_ICON : EXPANDED_ICON}>
                <LogoBox size={iconSize} src={reportsIcon}/>
              </ListItemIcon>
              {!collapsed && (
                <>
                  <ListItemText primary="Reports" primaryTypographyProps={{style: MENU_FONT(fontSize)}}/>
                  {reportsOpen ? <ExpandLess style={{color: MENU_TEXT_COLOR}}/> : <ExpandMore style={{color: MENU_TEXT_COLOR}}/>}
                </>
              )}
            </ListItem>
          </PrimaryNavLink>

          <Collapse in={reportsOpen && !collapsed} timeout="auto" unmountOnExit>
            <List disablePadding style={{paddingLeft: 24}}>
              <PermissionOnly permissions={PERMISSIONS.REPORTS_EXPORT}>
                <PrimaryNavLink activeClassName={classes.activeClassName} onClick={onNavClick} to={`${match.url}/reports/monthly-summary`}>
                  <MenuItem iconSize={16} fontSize={13} icon={monthSummaryIcon} label="Monthly Summary" collapsed={collapsed}/>
                </PrimaryNavLink>
              </PermissionOnly>

              <PermissionOnly permissions={PERMISSIONS.TRANSACTIONS_READ}>
                <PrimaryNavLink activeClassName={classes.activeClassName} onClick={onNavClick} to={`${match.url}/reports/transactions`}>
                  <MenuItem iconSize={16} fontSize={13} icon={transactionIcon} label="Transactions" collapsed={collapsed}/>
                </PrimaryNavLink>
              </PermissionOnly>

              <PermissionOnly permissions={PERMISSIONS.REPORTS_EXPORT}>
                <PrimaryNavLink activeClassName={classes.activeClassName} onClick={onNavClick} to={`${match.url}/reports/data-export`}>
                  <MenuItem iconSize={16} fontSize={13} icon={dataExportIcon} label="Data Export" collapsed={collapsed}/>
                </PrimaryNavLink>
              </PermissionOnly>

              <PermissionOnly permissions={PERMISSIONS.REPORTS_EXPORT}>
                <PrimaryNavLink activeClassName={classes.activeClassName} onClick={onNavClick} to={`${match.url}/reports/parking-inventory`}>
                  <MenuItem iconSize={16} fontSize={13} icon={parkingLotIcon} label="Parking Inventory" collapsed={collapsed}/>
                </PrimaryNavLink>
              </PermissionOnly>
            </List>
          </Collapse>
        </PermissionOnly>

        {insightsEnabled ? (
          <PermissionOnly permissions={INSIGHTS_PAGE_PERMISSIONS}>
            <>
              <PrimaryNavLink component="div" onClick={handleInsightsClick}>
                <ListItem button style={collapsed ? COLLAPSED_ITEM : EXPANDED_ITEM}>
                  <ListItemIcon style={collapsed ? COLLAPSED_ICON : EXPANDED_ICON}>
                    <LogoBox size={iconSize} src={dashboardIcon}/>
                  </ListItemIcon>
                  {!collapsed && (
                    <>
                      <ListItemText primary="Insights" primaryTypographyProps={{style: MENU_FONT(fontSize)}}/>
                      {insightsOpen ? <ExpandLess style={{color: MENU_TEXT_COLOR}}/> : <ExpandMore style={{color: MENU_TEXT_COLOR}}/>}
                    </>
                  )}
                </ListItem>
              </PrimaryNavLink>
              <Collapse in={insightsOpen && !collapsed} timeout="auto" unmountOnExit>
                <List disablePadding style={{paddingLeft: 24}}>
                  {isInsightTabEnabled(facility, "overview") ? (
                    <PermissionOnly permissions={INSIGHT_TAB_PERMISSIONS.overview}>
                    <PrimaryNavLink activeClassName={classes.activeClassName} onClick={onNavClick} to={`${match.url}/insights/overview`}>
                      <MenuItem iconSize={16} fontSize={13} icon={dashboardIcon} label="Overview" collapsed={collapsed}/>
                    </PrimaryNavLink>
                    </PermissionOnly>
                  ) : null}
                  {isInsightTabEnabled(facility, "leakage") ? (
                    <PermissionOnly permissions={INSIGHT_TAB_PERMISSIONS.leakage}>
                    <PrimaryNavLink activeClassName={classes.activeClassName} onClick={onNavClick} to={`${match.url}/insights/leakage`}>
                      <MenuItem iconSize={16} fontSize={13} icon={transactionIcon} label="Leakage" collapsed={collapsed}/>
                    </PrimaryNavLink>
                    </PermissionOnly>
                  ) : null}
                  {isInsightTabEnabled(facility, "channels") ? (
                    <PermissionOnly permissions={INSIGHT_TAB_PERMISSIONS.channels}>
                    <PrimaryNavLink activeClassName={classes.activeClassName} onClick={onNavClick} to={`${match.url}/insights/channels`}>
                      <MenuItem iconSize={16} fontSize={13} icon={dataExportIcon} label="Channels" collapsed={collapsed}/>
                    </PrimaryNavLink>
                    </PermissionOnly>
                  ) : null}
                  {isInsightTabEnabled(facility, "staff") ? (
                    <PermissionOnly permissions={INSIGHT_TAB_PERMISSIONS.staff}>
                    <PrimaryNavLink activeClassName={classes.activeClassName} onClick={onNavClick} to={`${match.url}/insights/staff`}>
                      <MenuItem iconSize={16} fontSize={13} icon={users} label="Staff" collapsed={collapsed}/>
                    </PrimaryNavLink>
                    </PermissionOnly>
                  ) : null}
                  {isInsightTabEnabled(facility, "network") ? (
                    <PermissionOnly permissions={INSIGHT_TAB_PERMISSIONS.network}>
                    <PrimaryNavLink activeClassName={classes.activeClassName} onClick={onNavClick} to={`${match.url}/insights/network`}>
                      <MenuItem iconSize={16} fontSize={13} icon={monthSummaryIcon} label="Network" collapsed={collapsed}/>
                    </PrimaryNavLink>
                    </PermissionOnly>
                  ) : null}
                  {isInsightTabEnabled(facility, "arrivals") ? (
                    <PermissionOnly permissions={INSIGHT_TAB_PERMISSIONS.arrivals}>
                    <PrimaryNavLink activeClassName={classes.activeClassName} onClick={onNavClick} to={`${match.url}/insights/arrivals`}>
                      <MenuItem iconSize={16} fontSize={13} icon={bookingIcon} label="Arrivals & Departures" collapsed={collapsed}/>
                    </PrimaryNavLink>
                    </PermissionOnly>
                  ) : null}
                  {isInsightTabEnabled(facility, "ops") ? (
                    <PermissionOnly permissions={INSIGHT_TAB_PERMISSIONS.ops}>
                    <PrimaryNavLink activeClassName={classes.activeClassName} onClick={onNavClick} to={`${match.url}/insights/ops`}>
                      <MenuItem iconSize={16} fontSize={13} icon={parkingLotIcon} label="Data Input" collapsed={collapsed}/>
                    </PrimaryNavLink>
                    </PermissionOnly>
                  ) : null}
                </List>
              </Collapse>
            </>
          </PermissionOnly>
        ) : null}

        {/* Concierge menu with subpages */}
        <PermissionOnly permissions={PERMISSIONS.DASHBOARD_READ}>
          {conciergeEnabled ? (
            <>
              <PrimaryNavLink component="div" onClick={handleConciergeClick}>
                <ListItem button style={collapsed ? COLLAPSED_ITEM : EXPANDED_ITEM}>
                  <ListItemIcon style={collapsed ? COLLAPSED_ICON : EXPANDED_ICON}>
                    <LogoBox size={iconSize} src={guestCardIcon}/>
                  </ListItemIcon>
                  {!collapsed && (
                    <>
                      <ListItemText primary="Concierge" primaryTypographyProps={{style: MENU_FONT(fontSize)}}/>
                      {conciergeOpen ? <ExpandLess style={{color: MENU_TEXT_COLOR}}/> : <ExpandMore style={{color: MENU_TEXT_COLOR}}/>}
                    </>
                  )}
                </ListItem>
              </PrimaryNavLink>
              <Collapse in={conciergeOpen && !collapsed} timeout="auto" unmountOnExit>
                <List disablePadding style={{paddingLeft: 24}}>
                  {isConciergePageEnabled(facility, "dashboard") ? (
                    <PrimaryNavLink activeClassName={classes.activeClassName} onClick={onNavClick} to={`${match.url}/concierge/dashboard`}>
                      <MenuItem iconSize={16} fontSize={13} icon={dashboardIcon} label="Dashboard" collapsed={collapsed}/>
                    </PrimaryNavLink>
                  ) : null}
                  <PermissionOnly permissions={PERMISSIONS.RUNNER_QUEUE_MANAGE}>
                    <PrimaryNavLink activeClassName={classes.activeClassName} onClick={onNavClick} to={`${match.url}/runner`}>
                      <MenuItem iconSize={16} fontSize={13} icon={parkingLotIcon} label="Runner Queue" collapsed={collapsed}/>
                    </PrimaryNavLink>
                  </PermissionOnly>
                  {isConciergePageEnabled(facility, "vipRouting") ? (
                    <PrimaryNavLink activeClassName={classes.activeClassName} onClick={onNavClick} to={`${match.url}/concierge/vip-routing`}>
                      <MenuItem iconSize={16} fontSize={13} icon={sanctionedPlateIcon} label="VIP Routing" collapsed={collapsed}/>
                    </PrimaryNavLink>
                  ) : null}
                  {isConciergePageEnabled(facility, "vipAlerts") ? (
                    <PrimaryNavLink activeClassName={classes.activeClassName} onClick={onNavClick} to={`${match.url}/concierge/vip-alerts`}>
                      <MenuItem iconSize={16} fontSize={13} icon={sanctionedPlateIcon} label="VIP Alert Logs" collapsed={collapsed}/>
                    </PrimaryNavLink>
                  ) : null}
                  {isConciergePageEnabled(facility, "shifts") ? (
                    <PrimaryNavLink activeClassName={classes.activeClassName} onClick={onNavClick} to={`${match.url}/concierge/shifts`}>
                      <MenuItem iconSize={16} fontSize={13} icon={sanctionedTimeIcon} label="Runner Shifts" collapsed={collapsed}/>
                    </PrimaryNavLink>
                  ) : null}
                  {isConciergePageEnabled(facility, "porters") ? (
                    <PrimaryNavLink activeClassName={classes.activeClassName} onClick={onNavClick} to={`${match.url}/concierge/porters`}>
                      <MenuItem iconSize={16} fontSize={13} icon={users} label="Porters" collapsed={collapsed}/>
                    </PrimaryNavLink>
                  ) : null}
                  {isConciergePageEnabled(facility, "parkingAudit") ? (
                    <PrimaryNavLink activeClassName={classes.activeClassName} onClick={onNavClick} to={`${match.url}/concierge/parking-audit`}>
                      <MenuItem iconSize={16} fontSize={13} icon={payoutsIcon} label="Parking Audit" collapsed={collapsed}/>
                    </PrimaryNavLink>
                  ) : null}
                </List>
              </Collapse>
            </>
          ) : null}
        </PermissionOnly>

        <PermissionOnly permissions={[PERMISSIONS.SANCTIONED_TIMES_READ, PERMISSIONS.SANCTIONED_TIMES_MANAGE]}>
          <PrimaryNavLink activeClassName={classes.activeClassName} onClick={onNavClick} to={`${match.url}/settings/sanctioned`}>
            <MenuItem iconSize={iconSize} fontSize={fontSize} icon={sanctionedTimeIcon} label="Sanctioned Times" collapsed={collapsed}/>
          </PrimaryNavLink>
        </PermissionOnly>

        <PermissionOnly permissions={[PERMISSIONS.USERS_READ, PERMISSIONS.USERS_MANAGE]}>
          <PrimaryNavLink activeClassName={classes.activeClassName} onClick={onNavClick} to={`${match.url}/settings/users`}>
            <MenuItem iconSize={iconSize} fontSize={fontSize} icon={users} label="Users" collapsed={collapsed}/>
          </PrimaryNavLink>
        </PermissionOnly>

        <PermissionOnly permissions={PERMISSIONS.USERS_MANAGE}>
          <PrimaryNavLink activeClassName={classes.activeClassName} onClick={onNavClick} to={`${match.url}/settings/roles`}>
            <MenuItem iconSize={iconSize} fontSize={fontSize} icon={users} label="User Roles" collapsed={collapsed}/>
          </PrimaryNavLink>
        </PermissionOnly>

        <PermissionOnly permissions={[PERMISSIONS.SANCTIONED_PLATES_READ, PERMISSIONS.SANCTIONED_PLATES_MANAGE]}>
          <PrimaryNavLink activeClassName={classes.activeClassName} onClick={onNavClick} to={`${match.url}/settings/plates`}>
            <MenuItem iconSize={iconSize} fontSize={fontSize} icon={sanctionedPlateIcon} label="Sanctioned Plates" collapsed={collapsed}/>
          </PrimaryNavLink>
        </PermissionOnly>
      </List>
    );
}

export default withInstallation(SidebarMenu);

export function SidebarBottomMenuComponent({match, collapsed, iconSize, fontSize, onNavClick, installation}) {
    const classes = useStyles();
    const currentRole = authManager.currentRoleAt(installation?.id);

    return (
        <List disablePadding style={{padding: '8px 4px'}}>
            <PrimaryNavLink activeClassName={classes.activeClassName} onClick={onNavClick} to={`${match.url}/profile`}>
                <ListItem button style={collapsed ? COLLAPSED_ITEM : EXPANDED_ITEM}>
                    <ListItemIcon style={collapsed ? COLLAPSED_ICON : EXPANDED_ICON}><LogoBox size={iconSize} src={users}/></ListItemIcon>
                    {!collapsed && (
                        <ListItemText
                            primary={<CurrentUserName/>}
                            secondary={currentRole}
                            primaryTypographyProps={{style: MENU_FONT(fontSize)}}
                            secondaryTypographyProps={{
                                style: {
                                    ...MENU_FONT(Math.max(fontSize - 2, 11)),
                                    opacity: 0.7,
                                },
                            }}
                        />
                    )}
                </ListItem>
            </PrimaryNavLink>
            <PrimaryNavLink component="div" onClick={() => authManager.logout()}>
                <MenuItem iconSize={iconSize} fontSize={fontSize} icon={logoutIcon} label="Sign Out" collapsed={collapsed}/>
            </PrimaryNavLink>
        </List>
    );
}

export const SidebarBottomMenu = withInstallation(SidebarBottomMenuComponent);
